export default __webpack_public_path__ + "media/images/favicon/mstile-70-4e8f842a6d8697d4bf2635bd95ad7944.png";